import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Modal, ButtonToolbar, Button} from 'react-bootstrap'
import moment from 'moment'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import extract from '../../core/extract'
import {linkFinder, relFilter} from '../../core/links'
import Icon from '../../core/components/Icon'
import RadioToggle from '../../core/components/RadioToggle'
import Card from '../../core/components/Card'
import Tag from '../../core/components/Tag'
import LoaderButton from '../../core/components/LoaderButton'
import DayPicker from '../../core/components/DayPicker'
import TimePicker from '../../core/components/TimePicker'
import {CLOSE_TICKET_CMD_TYPES, StartInterventionCmd, FinishInterventionCmd, CloseTicketCmd} from '../models'
import {START_INTERVENTION_CMD_UPDATED, FINISH_INTERVENTION_CMD_UPDATED, CLOSE_TICKET_CMD_UPDATED, sendStartInterventionCmd, sendFinishInterventionCmd, sendCloseTicketCmd, loadTicket, updateCloseTicketCmd, updateStartInterventionCmd, updateFinishInterventionCmd} from '../actions'
import i18n from '../i18n'
import style from './CloseTicketCard.less'

function restrict(allowed, value) {
    if (value) return allowed.indexOf(value) >= 0 && value || undefined
    return undefined
}

class CloseTicketCard extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            cmdTypes: []
        }
    }

    _initInterventionDates(ticket, dispatch) {
        const iStarted = ticket.journal
            .filter ( e => e.eventName === 'InterventionStarted' )
            .map ( e => [new Date(e.data.sentDate), e] )
            .sort((d1,d2) => d2[0].getTime() - d1[0].getTime())

        const iFinished = ticket.journal
            .filter ( e => e.eventName === 'InterventionFinished' )
            .map ( e => [new Date(e.data.sentDate), e] )
            .sort((d1,d2) => d2[0].getTime() - d1[0].getTime())

        const interventionStarted = (iStarted && iStarted.length > 0) ? iStarted[0][1].date : null
        const interventionFinished = (iFinished && iFinished.length > 0) ? iFinished[0][1].date : null

        dispatch(updateStartInterventionCmd({startedDate: interventionStarted && moment(interventionStarted).format()}))
        dispatch(updateFinishInterventionCmd({finishedDate: interventionFinished && moment(interventionFinished).format()}))
    }

    componentWillMount() {
        const {dispatch, closeTicketCmd, ticket} = this.props

        const cmdTypes = CLOSE_TICKET_CMD_TYPES.filter(relFilter(ticket._links))
        this.setState({cmdTypes})

        dispatch(updateCloseTicketCmd({
            commandType: restrict(cmdTypes, closeTicketCmd && closeTicketCmd.commandType)
        }))

        this._initInterventionDates(ticket, dispatch)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket != this.props.ticket) {
            const {dispatch, closeTicketCmd, ticket} = nextProps

            const cmdTypes = CLOSE_TICKET_CMD_TYPES.filter(relFilter(ticket._links))
            this.setState({cmdTypes})

            dispatch(updateCloseTicketCmd({
                commandType: restrict(cmdTypes, closeTicketCmd && closeTicketCmd.commandType)
            }))

            this._initInterventionDates(ticket, dispatch)
        }
    }

    _sendInterventionCmd = () => {
        const {dispatch, startInterventionForm, finishInterventionForm} = this.props

        return Promise.resolve(true).then(() => {
            return startInterventionForm.isValid() && dispatch(sendStartInterventionCmd())
        }).then(() => {
            return finishInterventionForm.isValid() && dispatch(sendFinishInterventionCmd())
        }).then(() => {
            return dispatch(loadTicket())
        })
    }

    _sendCmd() {
        const {dispatch} = this.props

        return Promise.resolve(true)/*.then(() => {
            return startInterventionForm.isValid() && dispatch(sendStartInterventionCmd())
        }).then(() => {
            return finishInterventionForm.isValid() && dispatch(sendFinishInterventionCmd())
        })*/.then(() => {
            return dispatch(sendCloseTicketCmd())    
        }).then(() => {
            return dispatch(loadTicket())
        })
    }

    _openModal(event, name) {
        event.preventDefault()
        this.setState({openedModal: name})
    }

    _closeModal() {
        this.setState({openedModal: null})
    }

    render() {
        const {dispatch, startInterventionForm, finishInterventionForm, closeTicketForm, startInterventionCmd, finishInterventionCmd, closeTicketCmd, ticket, ...others} = this.props
        const {cmdTypes, openedModal} = this.state

        const cmdTypeCheckbox = (cmdType) => (
            <li key={cmdType}>
                <label>
                    <input
                        type='checkbox'
                        value={cmdType} />
                    {extract(i18n.cmdTypeEnum, cmdType)}
                </label>
            </li>
        )

        return (
            <div>
                <Card header={<h5>{i18n.interventionDetail}</h5>}
                            {...others}>
                    <div>
                        <Row>
                            <Col sm={1}></Col>
                            <Col sm={5}>
                                {ticket._links.find(linkFinder('StartIntervention')) && (
                                    <p className={style.interventionDate}>
                                        <a
                                            href=''
                                            onClick={(e) => this._openModal(e, 'StartInterventionModal')}>
                                            <Icon icon='calendar' size='xs' />
                                            <span> {i18n.startInterventionDate} : </span>
                                            {!(startInterventionCmd && startInterventionCmd.startedDate) && (
                                                <Icon icon='plus' size='xs' />
                                            )}
                                        </a>
                                        <Tag
                                            size='sm'
                                            position='right'
                                            display={(d) => moment(d).format(i18n.dateTimeFormat.default)}
                                            {...startInterventionForm.startedDate()} />
                                    </p>
                                )}
                            </Col>
                            <Col sm={5}>
                                {ticket._links.find(linkFinder('FinishIntervention')) && (
                                    <p className={style.interventionDate}>
                                        <a
                                            href=''
                                            onClick={(e) => this._openModal(e, 'FinishInterventionModal')}>
                                            <Icon icon='calendar' size='xs' />
                                            <span> {i18n.finishInterventionDate} : </span>
                                            {!(finishInterventionCmd && finishInterventionCmd.finishedDate) && (
                                                <Icon icon='plus' size='xs' />
                                            )}
                                        </a>
                                        <Tag
                                            size='sm'
                                            position='right'
                                            display={(d) => moment(d).format(i18n.dateTimeFormat.default)}
                                            {...finishInterventionForm.finishedDate()} />
                                    </p>
                                )}
                            </Col>
                            <Col sm={1}></Col>
                        </Row>
                        <ButtonToolbar>
                            <LoaderButton
                                bsStyle='primary'
                                bsSize='large'
                                disabled={!(startInterventionForm.isValid() || finishInterventionForm.isValid())}
                                onClick={this._sendInterventionCmd}>
                                {i18n.interventionFilled}
                            </LoaderButton>
                        </ButtonToolbar>
                    </div>
                </Card>
                <Card
                    header={<h5>{i18n.closeTicket}</h5>}
                    {...others}>
                    <div className={style.cmdType}>
                        <RadioToggle
                            {...closeTicketForm.commandType()}>
                            <Row>
                                <Col sm={4}>
                                    <ul>
                                        {cmdTypes.slice(0, 2).map(cmdTypeCheckbox)}
                                    </ul>
                                </Col>
                                <Col sm={4}>
                                    <ul>
                                        {cmdTypes.slice(2, 4).map(cmdTypeCheckbox)}
                                    </ul>
                                </Col>
                                <Col sm={4}>
                                    <ul>
                                        {cmdTypes.slice(4, 6).map(cmdTypeCheckbox)}
                                    </ul>
                                </Col>
                            </Row>
                        </RadioToggle>
                    </div>
                    <Row>
                        {/*<Col sm={6}>
                            {ticket._links.find(linkFinder('StartIntervention')) && (
                                <p className={style.interventionDate}>
                                    <a
                                        href=''
                                        onClick={(e) => this._openModal(e, 'StartInterventionModal')}>
                                        <Icon icon='calendar' size='xs' />
                                        <span> {i18n.startInterventionDate} : </span>
                                        {!(startInterventionCmd && startInterventionCmd.startedDate) && (
                                            <Icon icon='plus' size='xs' />
                                        )}
                                    </a>
                                    <Tag
                                        size='sm'
                                        position='right'
                                        display={(d) => moment(d).format(i18n.dateTimeFormat.default)}
                                        {...startInterventionForm.startedDate()} />
                                </p>
                            )}
                            {ticket._links.find(linkFinder('FinishIntervention')) && (
                                <p className={style.interventionDate}>
                                    <a
                                        href=''
                                        onClick={(e) => this._openModal(e, 'FinishInterventionModal')}>
                                        <Icon icon='calendar' size='xs' />
                                        <span> {i18n.finishInterventionDate} : </span>
                                        {!(finishInterventionCmd && finishInterventionCmd.finishedDate) && (
                                            <Icon icon='plus' size='xs' />
                                        )}
                                    </a>
                                    <Tag
                                        size='sm'
                                        position='right'
                                        display={(d) => moment(d).format(i18n.dateTimeFormat.default)}
                                        {...finishInterventionForm.finishedDate()} />
                                </p>
                            )}
                        </Col>*/}
                        <Col sm={12}>
                            {closeTicketForm.report && (
                                <Input
                                    type='textarea'
                                    placeholder={i18n.closingReport}
                                    {...closeTicketForm.report()} />
                            )}
                            {closeTicketForm.comment && (
                                <Input
                                    type='textarea'
                                    placeholder={i18n.comment}
                                    {...closeTicketForm.comment()} />
                            )}
                        </Col>
                    </Row>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !closeTicketForm.isValid()})}
                            onClick={() => closeTicketForm.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.closeTicket}
                        </LoaderButton>
                    </ButtonToolbar>
                </Card>
                <Modal
                    bsSize='small'
                    show={openedModal == 'StartInterventionModal'}
                    onHide={() => this._closeModal()}>
                    <Modal.Header>
                        <Modal.Title>{i18n.startInterventionDate}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={style.interventionDateTimePicker}>
                            <div className={style.container}>
                                <DayPicker
                                    {...startInterventionForm.startedDate()} />
                                <TimePicker
                                    {...startInterventionForm.startedDate()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal
                    bsSize='small'
                    show={openedModal == 'FinishInterventionModal'}
                    onHide={() => this._closeModal()}>
                    <Modal.Header>
                        <Modal.Title>{i18n.finishInterventionDate}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={style.interventionDateTimePicker}>
                            <div className={style.container}>
                                <DayPicker
                                    {...finishInterventionForm.finishedDate()} />
                                <TimePicker
                                    {...finishInterventionForm.finishedDate()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

CloseTicketCard = connectForm({
    name: 'startInterventionForm',
    target: 'startInterventionCmd',
    alias: 'cmd',
    schema: StartInterventionCmd.schema,
    action: START_INTERVENTION_CMD_UPDATED
})(CloseTicketCard)

CloseTicketCard = connectForm({
    name: 'finishInterventionForm',
    target: 'finishInterventionCmd',
    alias: 'cmd',
    schema: FinishInterventionCmd.schema,
    action: FINISH_INTERVENTION_CMD_UPDATED
})(CloseTicketCard)

CloseTicketCard = connectForm({
    name: 'closeTicketForm',
    target: 'closeTicketCmd',
    alias: 'cmd',
    schema: CloseTicketCmd.selectSchema,
    action: CLOSE_TICKET_CMD_UPDATED
})(CloseTicketCard)

CloseTicketCard = connect((state) => ({
    ticket: state.ticket.ticket,
    startInterventionCmd: state.ticket.startInterventionCmd,
    finishInterventionCmd: state.ticket.finishInterventionCmd,
    closeTicketCmd: state.ticket.closeTicketCmd
}))(CloseTicketCard)

export default CloseTicketCard


// WEBPACK FOOTER //
// ./lib/ticket/components/CloseTicketCard.js